module.exports = __webpack_public_path__ + "img/ico-instagram-circle.06a4187e.svg";